import EntityLayer from 'app/containers/Maps/EntityLayerStyling/EntityLayer';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { loadMultipleEntities, saveLayerFeatures, setLayerLoading } from 'store/actions/maps/situationalAwarenessActions';
import store from 'store/Store';
import { processEntityIconInheritance } from './Common/processEntityIconInheritance';
import { calculateLayerZIndex } from 'app/config/layerZIndexConfig';
import { LAYERS, normalizeVisibility } from 'app/utils/maps/layer/layerUtils';
import { bind } from 'app/utils/decorators/decoratorUtils';

class ReplayLayer extends EntityLayer {
    constructor(info, map) {
        super(info, map);
        this._isLoadingEntities = false;
        this._lastLoadedEntities = null;
    }

    @bind
    async loadEntities() {
        if (this._isLoadingEntities) {
            return this._lastLoadedEntities;
        }

        const { relatedEntities = [] } = this.info || {};
        const layerSpecificEntities = relatedEntities.filter(entity =>
            !entity.layerId || entity.layerId === this.info.id);

        const entityRequests = layerSpecificEntities.map(entity => ({
            type: entity.type,
            id: entity.id
        }));

        if (entityRequests.length === 0) {
            store.dispatch(saveLayerFeatures(this.info.id, []));
            return [];
        }

        this._isLoadingEntities = true;

        try {
            const fetchedEntities = await store.dispatch(loadMultipleEntities(entityRequests));
            const processedEntities = processEntityIconInheritance(fetchedEntities).map(entity => ({
                ...entity,
                layerId: this.info.id
            }));

            this._lastLoadedEntities = processedEntities;
            store.dispatch(saveLayerFeatures(this.info.id, processedEntities));
            return processedEntities;
        } catch (error) {
            console.error('Error loading entities:', error);
            store.dispatch(saveLayerFeatures(this.info.id, []));
            return [];
        } finally {
            this._isLoadingEntities = false;
        }
    }

    @bind
    async loader(extent, resolution, projection) {
        await this.loadEntities();
        store.dispatch(setLayerLoading(this.info.id));
    }

    @bind
    getDataSource() {
        if (!this.dataSource) {
            this.dataSource = new VectorSource({
                loader: this.loader,
            });
        }
        return this.dataSource;
    }

    async setLayer() {
        try {
            const { name, filters, type, id, entity_type, visible, classData, opacity, relatedEntities = [], zIndex } = this.info || {};

            const normalizedVisible = normalizeVisibility(visible);

            this.layer = new VectorLayer({
                name: id,
                title: name,
                visible: normalizedVisible,
                opacity,
                type,
                attributes: {
                    id,
                    type: LAYERS.replay,
                    entityType: entity_type?.uri,
                    subtitle: 'entities',
                    layerType: 'Replay Layer',
                    iconName: 'play',
                    iconType: 'mdi',
                    visible: normalizedVisible,
                    classData,
                    filters
                },
                source: this.getDataSource(),
                zIndex: typeof zIndex === 'number' ? zIndex : calculateLayerZIndex(LAYERS.replay),
            });

            await this.addLayerToMap();

            if (normalizedVisible && relatedEntities && relatedEntities.length > 0) {
                this.loadEntities();
            }

        } catch (error) {
            console.error('Error setting layer:', error);
        }
    }
}

export default ReplayLayer;